




















































































import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Home extends Vue {
  public limit = 0;
  public list = [
    {
      title: "传奇脚本技术",
      address: "杭州市 · 萧山区 · 钱江世纪城",
      time: "全职 | 招聘中",
      list: [
        {
          className: "",
          desc:
            "1、要求对传奇引擎GOM GEE BLUE GOB HGE等引擎使用熟悉其中一款即可",
        },
        {
          className: "",
          desc: "2、能使用引擎脚本，写出指定功能，能灵活运用引擎的变量",
        },
        {
          className: "",
          desc: "3、吃苦耐劳，责任心强，有较强的学习能力和团队合作精神。",
        },
        {
          className: "",
          desc: "4、工作时间：早上9点到晚上18点 每个月休息6天 法定假日正常休息",
        },
        {
          className: "",
          desc: "5、薪资待遇详聊 QQ：9555092 微信：gameip",
        },
        {
          className: "mt",
          desc:
            "愿您的加入给我们带来新的活力，我们也将为您提供广阔的发展空间！",
        },
        {
          className: "df",
          desc: "具有一定的管理领导能力，公司会提供良好的发展平台。",
        },
      ],
    },
    {
      title: "素材美术",
      address: "杭州市 · 萧山区 · 钱江世纪城",
      time: "全职 | 招聘中",
      list: [
        {
          className: "",
          desc: "1、熟悉热血传奇资源补丁结构和规则",
        },
        {
          className: "",
          desc: "2、会自己制作场景地图、UI、衣服武器等",
        },
        {
          className: "",
          desc: "3、吃苦耐劳，责任心强，有较强的学习能力和团队合作精神。",
        },
        {
          className: "",
          desc: "4、工作时间：早上9点到晚上18点 每个月休息6天 法定假日正常休息",
        },
        {
          className: "",
          desc: "5、薪资待遇详聊 QQ：9555092 微信：gameip",
        },
        {
          className: "mt",
          desc:
            "愿您的加入给我们带来新的活力，我们也将为您提供广阔的发展空间！",
        },
        {
          className: "df",
          desc: "具有一定的管理领导能力，公司会提供良好的发展平台。",
        },
      ],
    },
    {
      title: "传奇策划",
      address: "杭州市 · 萧山区 · 钱江世纪城",
      time: "全职 | 招聘中",
      list: [
        {
          className: "",
          desc: "1、熟悉市面上热门版本,对游戏玩法有一定的理解.",
        },
        {
          className: "",
          desc: "2、策划过热门的传奇版本,有从事过策划工作经历",
        },
        {
          className: "",
          desc: "3、吃苦耐劳，责任心强，有较强的学习能力和团队合作精神。",
        },
        {
          className: "",
          desc: "4、工作时间：早上9点到晚上18点 每个月休息6天 法定假日正常休息",
        },
        {
          className: "",
          desc: "5、薪资待遇详聊 QQ：9555092 微信：gameip",
        },
        {
          className: "mt",
          desc:
            "愿您的加入给我们带来新的活力，我们也将为您提供广阔的发展空间！",
        },
        {
          className: "df",
          desc: "具有一定的管理领导能力，公司会提供良好的发展平台。",
        },
      ],
    },
    {
      title: "引擎开发",
      address: "杭州市 · 萧山区 · 钱江世纪城",
      time: "全职 | 招聘中",
      list: [
        {
          className: "",
          desc: "1、3年以上Delphi游戏服务端开发任职经验, 熟悉传世功能开发.",
        },
        {
          className: "",
          desc:
            "2、熟练使用Delphi（D2007及以上）开发工具，掌握常用组件，接口，对象及设计模式；",
        },
        {
          className: "",
          desc: "3、熟悉服务端SOCKET网络编程，对TCP/IP协议有深入了解；",
        },
        {
          className: "",
          desc: "4、吃苦耐劳，责任心强，有较强的学习能力和团队合作精神。",
        },
        {
          className: "",
          desc: "5、工作时间：早上9点到晚上18点 每个月休息6天 法定假日正常休息",
        },
        {
          className: "",
          desc: "6、薪资待遇详聊 QQ：5158883 微信：little20201216",
        },
        {
          className: "mt",
          desc:
            "愿您的加入给我们带来新的活力，我们也将为您提供广阔的发展空间！",
        },
        {
          className: "df",
          desc: "具有一定的管理领导能力，公司会提供良好的发展平台。",
        },
      ],
    },
    {
      title: "Cocos2dx手游开发",
      address: "杭州市 · 萧山区 · 钱江世纪城",
      time: "全职 | 招聘中",
      list: [
        {
          className: "",
          desc: "1、按照策划需求，独立开发的手游功能，UI制作；",
        },
        {
          className: "",
          desc: "2、维护已有模块，解决游戏功能bug；",
        },
        {
          className: "mt",
          desc: "任职资格：",
        },
        {
          className: "",
          desc:
            "1、至少2年的cocos2dx环境下lua实务开发经验，熟悉Cocos2dx游戏引擎，熟悉CocosStudio；",
        },
        {
          className: "",
          desc: "2、有责任感，执行力强，能够适应较高强度的工作;",
        },
        {
          className: "",
          desc: "3、有cocos2dx c++经验者优先；有传奇世界相关开发经验者优先；",
        },
        {
          className: "",
          desc: "5、薪资待遇详聊 2630959694",
        },
      ],
    },
  ];
  public setTab(index) {
    this.limit = index;
  }
}
